import { Pipe, PipeTransform } from '@angular/core';
import { DashboardColumn, Dashboard, Widget } from 'src/api/models';
import { WidgetType } from 'src/app/models/dashboard';

@Pipe({
  name: 'getWidgetSize'
})
export class GetWidgetSizePipe implements PipeTransform {

  transform(widget: Widget, dashboard: Dashboard, column: DashboardColumn): string {
    let index: number = dashboard.columns.indexOf(column);
    var smallSize = widget.size * 3;
    if (smallSize > 12) smallSize = 12;
    if (dashboard.layout == "Even"){
      var size = widget.size;
      if (widget.size < 6) {
        size = 6;
      }
      //var size = Math.min(Math.round(widget.size * 12), 12);
      var txt = "col-lg-" + size + " col-sm-" + size + " col-xs-" + smallSize;
      console.log(txt);
      return txt;
    }
    if (widget.size === 0) {
      // override size of widget to 12 if its not set otherwise the dashboard will fail to render correctly
      widget.size = 12;
    }

    if (index === 1) {
      // if the centre column, allow for modular width
      
      return "col-lg-" + widget.size + " col-sm-" + smallSize;
    }

    // if left or right column, static width is required.
    return "col-lg-12 col-sm-" + smallSize;
  }

}
